import {IWebMessagesState} from './webMessages.reducer'
import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';

const selectWebMessagesState: MemoizedSelector<object, IWebMessagesState> = createFeatureSelector<IWebMessagesState>('webMessages');
const getWebMessagesStatus = (state: IWebMessagesState): string => state.initiateHandshakeToken;

export const selectWebMessagesStatus: MemoizedSelector<object, string> = createSelector(selectWebMessagesState, getWebMessagesStatus);
